import { ScrollShadow } from "@nextui-org/react";
import { BiMapPin, BiSearch, BiTime } from "react-icons/bi";
import ChurchesBlock from "./churchs-block";

function generateTimeOptions(start = "04:00", end = "22:00", stepMinutes = 15) {
    const toMinutes = (hhmm) => {
        const [h, m] = hhmm.split(":").map(Number);
        return h * 60 + m;
    };
    const pad = (n) => n.toString().padStart(2, "0");
    const fmt = (mins) => `${pad(Math.floor(mins / 60))}:${pad(mins % 60)}`;

    const startMin = toMinutes(start);
    const endMin = toMinutes(end);
    const options = [];
    for (let t = startMin; t <= endMin; t += stepMinutes) {
        options.push(fmt(t));
    }
    return options;
}

export default function MassesTimeSearch({
    deaneries,
    handleSearch,
    searchData,
    churches,
    handleInputChange,
}) {
    const timeOptions = generateTimeOptions("04:00", "22:00", 15);

    return (
        // TODO:
        <div className="bg-gray-200 rounded-2xl p-6 shadow-lg">
            <div className="flex flex-col md:flex-row gap-3 mb-4">
                {/* Position Dropdown */}
                <div className="flex-1 relative">
                    <BiMapPin className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl" />
                    <select
                        value={searchData.appointmentID}
                        onChange={(e) =>
                            handleInputChange("appointmentID", e.target.value)
                        }
                        className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white cursor-pointer"
                    >
                        {deaneries.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                        <svg
                            className="w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                            />
                        </svg>
                    </div>
                </div>

                {/* Name/Title Input */}
                <div className="flex-1 relative">
                    <BiSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl" />
                    <input
                        type="text"
                        placeholder="Nhập tên giáo xứ"
                        value={searchData.churchName}
                        onChange={(e) =>
                            handleInputChange("churchName", e.target.value)
                        }
                        className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>

                {/* Parish Dropdown */}
                <div className="flex-1 relative">
                    <BiTime className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-xl" />
                    <select
                        value={searchData.timeMass}
                        onChange={(e) =>
                            handleInputChange("timeMass", e.target.value)
                        }
                        className="w-full pl-12 pr-4 py-3.5 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none bg-white cursor-pointer"
                    >
                        <option value="">Chọn giờ lễ</option>
                        {timeOptions.map((t) => (
                            <option key={t} value={t}>
                                {t}
                            </option>
                        ))}
                    </select>
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
                        <svg
                            className="w-4 h-4 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                            />
                        </svg>
                    </div>
                </div>

                {/* Search Button */}
                <button
                    onClick={handleSearch}
                    className="px-8 py-3.5 bg-cyan-500 hover:bg-cyan-600 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2 shadow-md"
                >
                    <BiSearch className="text-xl" />
                    <span>Tìm kiếm</span>
                </button>
            </div>
            {churches.total > 0 && (
                <>
                    <ScrollShadow
                        hideScrollBar
                        orientation="horizontal"
                        className="w-full h-[600px]"
                    >
                        <ChurchesBlock
                            churchData={churches}
                            isPagination={false}
                        />
                    </ScrollShadow>
                </>
            )}
        </div>
    );
}
